import React from 'react'

const NavTop = () => {
  return (
    <div>

<div className="landing-nav-top" >


<div>We do not offer Van Services.  </div>
<span>Towel must be provided by customer.</span>

  
</div>
        
    </div>
  )
}

export default NavTop